import {translate} from "@/domain/utils/translations";

export function buildOptions(params, lang) {
  const list = (params?.options || []).map(option => ({
    text: translate(option.label, lang),
    value: option.value
  }))
  if (params?.sort_alphabetically) {
    list.sort((a, b) => (a.text || '').localeCompare(b.text || '', lang, {sensitivity: 'base'}))
  }
  return list
}
